<template>
  <div>
    <table class="action-prop-table">
      <tr>
        <th>item id</th>
        <td>{{action.itemId}}</td>
      </tr>
      <tr>
        <th>product</th>
        <td>{{action.productId | getProtoAlias}}</td>
      </tr>
    </table>

    <table class="action-prop-table">
      <tr>
        <th>old amount</th>
        <td
          class="text-right"
        >
          {{action.oldAmount | getFormattedNumber}}
        </td>
      </tr>
      <tr>
        <th>delta</th>
        <td
          class="text-right"
          :class="getDeltaClass(delta)"
        >
          {{delta | getFormattedDifference}}
        </td>
      </tr>
      <tr>
        <th>new amount</th>
        <td
          class="text-right"
        >
          {{action.newAmount | getFormattedNumber}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { getDeltaClass } from '../util';

export default {
  name: 'UserActionInfoSetPlayerInventoryItemAmount',

  props: {
    action: {
      type: Object,
      required: true,
    }
  },

  computed: {
    delta() {
      return this.action.newAmount - this.action.oldAmount;
    },
  },

  methods: {
    getDeltaClass,
  },
};
</script>
